import axiosInstance from '../axios';
import { timeUnix } from '../../utility/k_time';
import { qlubSessionStorage } from '../../service/storage/sessionStorage';
import { ICountryConfigCache, ICountryConfigResponse } from './type';
import { apiEndpoints } from './const';

const cacheName = 'qlub.country_config';

export default class GeneralAPIManager {
    public static getInstance() {
        if (!this.instance) {
            this.instance = new GeneralAPIManager();
        }

        return this.instance;
    }

    public constructor() {
        this.loadCache();
    }

    private static instance: GeneralAPIManager;

    private countryCache: { [name: string]: ICountryConfigCache } = {};

    public getCountry = (code: string): Promise<Record<string, any>> => {
        if (this.countryCache.hasOwnProperty(code)) {
            const cache = this.countryCache[code];
            if (timeUnix() - cache.time < 3600) {
                return Promise.resolve(cache.data);
            }
        }
        return axiosInstance
            .Get<ICountryConfigResponse>(`${apiEndpoints.country}/${code}`, {
                'axios-retry': {
                    retries: 3,
                },
            })
            .then((res) => {
                this.countryCache[code] = {
                    time: timeUnix(),
                    data: res.data?.data || {},
                };
                this.storeCache();
                return res.data?.data || {};
            });
    };

    private storeCache() {
        qlubSessionStorage.set(cacheName, JSON.stringify(this.countryCache));
    }

    private loadCache() {
        const d = qlubSessionStorage.get(cacheName);
        if (!d) {
            return;
        }
        try {
            this.countryCache = JSON.parse(d);
        } catch (e) {
            console.warn(e);
        }
    }
}

export * from './type';
